var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.$computedClass(_vm.coreOutlineFocus),style:(_vm.tdStyle),attrs:{"tabindex":"0","data-focus":"true","role":"gridcell"},on:{"keydown":_vm.onKeydown}},[_c('div',{staticClass:"cell-content"},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")]},{"content":_vm.content})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }